/**
 * @flow
 * @relayHash 22187a19545195453ebd06d258985d9c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getUserDataQueryVariables = {||};
export type getUserDataQueryResponse = {|
  +currentUser: ?{|
    +id: string,
    +firstName: string,
    +lastName: string,
    +email: string,
    +representativeImageUrl: ?string,
  |}
|};
export type getUserDataQuery = {|
  variables: getUserDataQueryVariables,
  response: getUserDataQueryResponse,
|};
*/


/*
query getUserDataQuery {
  currentUser {
    id
    firstName
    lastName
    email
    representativeImageUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "currentUser",
    "storageKey": null,
    "args": null,
    "concreteType": "UserNode",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "representativeImageUrl",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getUserDataQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getUserDataQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getUserDataQuery",
    "id": null,
    "text": "query getUserDataQuery {\n  currentUser {\n    id\n    firstName\n    lastName\n    email\n    representativeImageUrl\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '50f718ae5e4c74f8843099ea9ff96fd4';
module.exports = node;
